import { config } from '../config.env'

import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { notifyError, notifyInfo, notifySuccess } from '../components/NotifyToast'
import Loader from '../components/Loader'
import { login, user_data } from '../store/authSlice'
import * as apiAuth from '../services/ApiAuthentication'
import { jwtDecode } from 'jwt-decode';

export default function LoginThaID() {
    const dispatch = useDispatch()
    const [searchParams] = useSearchParams()
    const navigate = useNavigate()
    const startedRef = useRef(false);
    const [loading, setLoading] = useState(false)

    useEffect(() => {

        if (startedRef.current)
            return;
        startedRef.current = true;

        const loginBy = searchParams.get('login_by');
        const status = searchParams.get('status');
        const pid = searchParams.get('pid');

        if (loginBy !== "thaid") {
            notifyError('ไม่รองรับการล็อคอิน');
            setLoading(false);
            return;
        }
        if (status !== "success") {
            notifyError('ไม่สำเร็จ');
            setLoading(false);
            return;
        }
        if (!pid) {
            notifyError('ไม่มี pid');
            setLoading(false);
            return;
        }

        verify(pid);

    }, [])

    const verify = async (pid) => {

        try
        {
            const thaidUid = apiAuth.buildThaiDUid(pid);

            setLoading(true);
            const loginResult = (await apiAuth.login(pid, thaidUid))?.data;
            const info = (await apiAuth.information(pid))?.data?.data;
            setLoading(false);

            if (!info)
            {
                notifyError("ไม่พบขข้อมูล");
                navigate('/');
                return;
            }

            const basicInfo = {
                pid: pid,
                thaid_uid: thaidUid,
                user_type: "patient",
                pname: info.pname?.trim() || undefined,
                fname: info.fname?.trim() || undefined,
                lname: info.lname?.trim() || undefined,
            };


            if (!loginResult?.status || !loginResult?.data?.access_token || !loginResult?.data?.refresh_token)
            {
                dispatch(user_data(basicInfo));
                navigate('/consent');
                return;
            }

            const tokenData = jwtDecode(loginResult.data.access_token);
            dispatch(login({ "ExpireInTimestamp": tokenData.exp }));

            localStorage.setItem('pid', pid);
            localStorage.setItem('access_token', loginResult.data.access_token);
            localStorage.setItem('refresh_token', loginResult.data.refresh_token);

            dispatch(user_data({...basicInfo, ...info}));
            navigate('/mainMenu');

            /*
            dispatch(setSessionSucceeded());

            const profile = await loadProfile();
            const blockReason = getLoginAccessBlockReason(profile);

            if (blockReason) {
                setAccessBlockReason(blockReason);
                setLoading(true);
                dispatch(clearAuth());
                void logout();
                return;
            }

            router.replace(ROUTES.home);
            router.refresh();
            */
        } catch (e) {
            console.error(e);
            notifyError("ยืนยันไม่สำเร็จ");
            setLoading(false);
        }

    }

    const getParameter = async (pid, accessToken) => {
        if (pid && accessToken) {
            const data = jwtDecode(accessToken);
            console.log(data)

            dispatch(login({ "ExpireInTimestamp": data.exp }))
            localStorage.setItem('pid', pid)
            localStorage.setItem('access_token', accessToken)

            await profile()
        } else {
            notifyError('ไม่ตอบสนอง กรุณาติดต่อเจ้าหน้าที่')
        }

    }

    const profile = async () => {
        setLoading(true)
        let res = await apiAuth.profile()
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                dispatch(user_data(res['data']['data']))
                navigate('/consent')
            } else {
                notifyError(res['data']['message'])
            }
        } else {
            notifyError('ไม่ตอบสนอง')
        }
    }

    return (
        <>
            <Loader loading={loading} />
        </>
    )
}